export default __webpack_public_path__ + "static/media/twoPersonIcon.e2fb524a.svg";